import { Components } from "@thisgorilla/primate-ds";
import styled from "styled-components";
import ImgPreviewProps from "./ImgPreview";

const ImgPreview = ({ img, onDelete }: ImgPreviewProps.IProps) => {
  return (
    <ImageContainer>
      <Image $src={img} />
      <DeleteButton>
        <Components.IconButton
          disabled={false}
          iconType="X"
          kind="Opacity"
          onClick={onDelete}
          size="XXS"
        />
      </DeleteButton>
    </ImageContainer>
  );
};

export default ImgPreview;

const ImageContainer = styled.div`
  position: relative;
  width: fit-content;
  cursor: pointer;
`;
const DeleteButton = styled.div`
  position: absolute;
  top: -4px;
  right: -4px;
  z-index: 1;
  & > button {
    box-shadow: ${({ theme }) => theme.boxShadows["box-shadow-m"]};
  }
`;

const Image = styled.div<{ $src: string }>`
  display: block;
  width: ${({ theme }) => theme.spacing["spacing-12"].value}rem;
  height: ${({ theme }) => theme.spacing["spacing-12"].value}rem;
  border-radius: ${({ theme }) => theme.radius["radius-xs"].value}rem;
  border: 1px solid
    ${({ theme }) => theme.Color.border["ui-border-neutral"].value};
  background: url(${({ $src }) => $src}) lightgray 50% / cover no-repeat;
`;
